import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import case_under from "../../images/case_under.png";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { toast, ToastContainer } from "react-toastify";
const JobOpeningCard = ({ section }) => {
  // console.log("sdfs", searchResults);
  const [selectedJob, setSelectedJob] = useState({});
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    resume: null,
    userPhoto: null,
  });
  const route = useParams();
  function formatDate(dateStr) {
    const date = new Date(dateStr);

    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];

    return {
      day: day,
      month: month,
      year: year,
    };
  }

  const inputStyle = {
    width: "100%",
    borderBottom: "1px solid #B5B5B6",
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    padding: "8px 8px 8px 0",
    textAlign: "left",
  };

  const fileInputContainerStyle = {
    borderBottom: "1px solid #B5B5B6",
    paddingBottom: ".5rem",
    width: "97%",
  };

  const fileInputStyle = {
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    textAlign: "left",
  };

  const submitButtonStyle = {
    fontSize: "16px",
    width: "118px",
    height: "43px",
    backgroundColor: "#0C807D",
    color: "#fff",
    textTransform: "capitalize",
    border: "none",
    borderRadius: "6px",
    fontWeight: 500,
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("type", "career_form");
    body.append("job_id", selectedJob.id);
    body.append("first_name", formData.firstName);
    body.append("last_name", formData.lastName);
    body.append("email", formData.email);
    body.append("department", "");
    body.append("expected_salary", "");
    body.append("cover_letter", "");
    body.append("status", "1");
    body.append("resume", formData.resume);
    body.append("user_photo", formData.userPhoto);
    try {
      const req = scAxiosAdmin
        .post(`/job_applications`, body, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        })
        .then((data) => {
          if (data.status === 201) {
            toast.success("Application Submitted Successfully");
          }
        })
        .catch((e) => {
          toast.error("Something went wrong!");
        });
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  return (
    <section className="container mt-4 mb-4">
      <h3
        style={{
          color: "#AF9763",
          fontWeight: "500",
        }}
        className="text-center mb-4"
      >
        {section.sectionTitle}
      </h3>
      <div class="row row-cols-1 row-cols-md-2 g-4">
        {section.value.length > 0
          ? section.value.map((job, index) => (
              <div class="col">
                <div class="card h-100 shadow">
                  <div
                    className="d-flex pt-3 pb-3 align-items-start px-3 gap-3"
                    style={{ backgroundColor: "#FEECDD" }}
                  >
                    {job.media.length > 0 ? (
                      <img
                        src={`${IMAGE_URL}${job.media[0]}`}
                        alt=""
                        style={{ width: "10%", height: "35px" }}
                      />
                    ) : (
                      <img
                        src="/assets/images/united_logo.png"
                        alt=""
                        style={{ width: "10%", height: "35px" }}
                      />
                    )}
                    {/* <img
                      className="ms-4"
                      src={case_under}
                      alt=""
                      width={3}
                      height={35}
                    /> */}
                    <h3
                      className="px-3"
                      style={{
                        fontSize: "22px",
                        textTransform: "capitalize",
                        borderLeft: "2px solid #F58220",
                      }}
                    >
                      {job.title}
                    </h3>
                  </div>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className="w-75"
                        dangerouslySetInnerHTML={{
                          __html: job.description
                            .split(" ")
                            .slice(0, 10)
                            .join(" "),
                        }}
                      ></div>

                      <div
                        style={{
                          borderRadius: "5px",
                          backgroundColor: "#FEF3E9",
                          maxWidth: isBrowser ? "100px" : "",
                        }}
                        className="d-flex flex-column align-items-center w-25"
                      >
                        <div
                          className="w-75 d-flex justify-content-center rounded-bottom"
                          style={{ backgroundColor: "#F58220" }}
                        >
                          <small
                            className="text-center text-white"
                            style={{ fontSize: isMobile ? "10px" : "" }}
                          >
                            Deadline
                          </small>
                        </div>
                        <div className="">
                          <h2 style={{ color: "#F58220" }}>
                            {formatDate(job.date).day}
                          </h2>
                        </div>
                        <div
                          className="w-100  d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#F58220",
                            borderBottomLeftRadius: "5px",
                            borderBottomRightRadius: "5px",
                          }}
                        >
                          <h6
                            className="mb-0 py-2"
                            style={{ color: "#ffffff" }}
                          >
                            {formatDate(job.date).month + " "}
                            {formatDate(job.date).year}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <p class="card-text">{job.short_description}</p>
                  </div>
                  <div
                    class="card-footer"
                    style={{ backgroundColor: "#FEECDD" }}
                  >
                    {/* <Link to={`/pages/career/${job.id}`}> */}
                    <button
                      className="px-3 py-1 "
                      type="button"
                      onClick={() => setSelectedJob(job)}
                      data-bs-toggle="modal"
                      data-bs-target="#jobModal"
                      style={{
                        borderRadius: "5px",
                        backgroundColor: "#F58220",
                        border: "none",
                        color: "white",
                      }}
                    >
                      View & Apply
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            ))
          : ""}
        {/* <div
          class="modal fade"
          id="jobModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="jobModalContent modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  {selectedJob.title}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body d-flex flex-column justify-content-between align-items-start">
                <div className="">
                  {selectedJob.media ? (
                    <img
                      src={`${IMAGE_URL}${selectedJob.media[0]}`}
                      alt=""
                      className="img-fluid w-100"
                    />
                  ) : (
                    <img
                      src="/assets/images/united_logo.png"
                      alt=""
                      className="img-fluid w-100"
                    />
                  )}
                </div>
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: selectedJob.description }}
                ></div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#0C807D",
                    border: "none",
                    color: "white",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div> */}
        <div
          class="modal fade"
          id="jobModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div
              class="jobModalContent modal-content mt-5"
              style={{ maxHeight: isBrowser ? "700px" : "500px" }}
            >
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  {selectedJob.title}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body d-flex flex-column justify-content-between align-items-start">
                <div className="w-100 mb-4">
                  {selectedJob.media ? (
                    <img
                      src={`${IMAGE_URL}${selectedJob.media[0]}`}
                      alt=""
                      className="img-fluid w-100"
                      style={{
                        maxHeight: "250px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  ) : (
                    <img
                      src="/assets/images/united_logo.png"
                      alt=""
                      className="img-fluid w-100"
                      style={{
                        maxHeight: "250px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  )}
                </div>
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: selectedJob.description }}
                ></div>
              </div>
              <div class="modal-footer">
                <button
                  class="px-3 py-2"
                  data-bs-target="#exampleModalToggle2"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#0C807D",
                    border: "none",
                    color: "white",
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="exampleModalToggle2"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel2"
          tabindex="-1"
        >
          <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
            <div
              class="modal-content mt-5"
              style={{ maxHeight: isBrowser ? "700px" : "500px" }}
            >
              <div class="modal-header">
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <h3
                      className="text-center"
                      style={{
                        color: "#0C807D",
                        fontSize: "28px",
                        fontWeight: "500",
                      }}
                    >
                      Upload Your CV
                    </h3>
                    <img
                      width={103}
                      height={2}
                      src="/assets/images/doctor_under.png"
                      alt=""
                    />
                  </div>
                </div>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <section class="container  pb-4">
                  <h3
                    style={{
                      color: "#0C807D",
                      fontSize: "28px",
                      fontWeight: "500",
                    }}
                    className="col-12 text-center"
                  >
                    {selectedJob.title}
                  </h3>
                  <div
                    class="row pt-5 pb-5 border justify-content-md-between"
                    style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }}
                  >
                    <div class="col-12 d-flex">
                      <form onSubmit={handleSubmit}>
                        <div className="row p-3 g-5 justify-content-around w-100">
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="First Name"
                              autoComplete="off"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleChange}
                              style={inputStyle}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              placeholder="Last Name"
                              autoComplete="off"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleChange}
                              style={inputStyle}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="email"
                              placeholder="Email Address"
                              autoComplete="off"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              style={inputStyle}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="tel"
                              placeholder="Phone Number"
                              autoComplete="off"
                              name="phoneNumber"
                              value={formData.phoneNumber}
                              onChange={handleChange}
                              style={inputStyle}
                            />
                          </div>
                          <div
                            className="col-md-12 px-0"
                            style={fileInputContainerStyle}
                          >
                            <div className="d-flex justify-content-between align-items-end flex-row w-100">
                              <p>Upload Image</p>
                              <input
                                className="w-100"
                                type="file"
                                name="userPhoto"
                                onChange={handleChange}
                                style={fileInputStyle}
                              />
                            </div>
                          </div>
                          <div
                            className="col-md-12 px-0"
                            style={fileInputContainerStyle}
                          >
                            <div className="d-flex justify-content-between align-items-end flex-row w-100">
                              <p>Resume/CV</p>
                              <input
                                className="w-100"
                                type="file"
                                name="resume"
                                onChange={handleChange}
                                style={fileInputStyle}
                              />
                            </div>
                          </div>
                          <div className="col-12 d-flex justify-content-center">
                            <button type="submit" style={submitButtonStyle}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </section>
              </div>
              <div class="modal-footer">
                <button
                  class="px-3 py-2"
                  data-bs-target="#jobModal"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#0C807D",
                    border: "none",
                    color: "white",
                  }}
                >
                  Back to first
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </section>
  );
};

export default JobOpeningCard;



// WEBPACK FOOTER //
// ./src/component/frontend/JobOpeningCard.js